{
  "version": 1,
  "asset_id": "cdaa3acf-391b-4393-a4f1-0892494e6902",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/cdaa3acf-391b-4393-a4f1-0892494e6902/marine-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/cdaa3acf-391b-4393-a4f1-0892494e6902/marine-card.webp",
  "original_filename": "marine-card.webp",
  "size": 26558,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:31:10Z"
}
